import { useCallback, useRef } from 'react';
import { useFocusEffect } from '@react-navigation/native';

/**
 * Ejecuta `reset` cuando el tab o pantalla pierde foco (p. ej. el usuario va a POS).
 * No resetea filtros ni paginación de listas — solo overlays y selección de detalle.
 */
export function useResetModuleUiOnBlur(reset: () => void) {
  const resetRef = useRef(reset);
  resetRef.current = reset;

  useFocusEffect(
    useCallback(() => {
      return () => {
        resetRef.current();
      };
    }, [])
  );
}
